<template>
  <div class="p-4">
    <v-form v-model="validForm" ref="form">
      <!-- Nome del modello -->
      <v-text-field
        v-model="risorsa.nome"
        label="Nome del modello"
        class="w-full"
        outlined
        :rules="[rules.required]"
        :readonly="onlyView"
        :disabled="onlyView"
        @input="$emit('modello-email-modifica-sospesa')"
      >
        <!-- Icona di blocco solo in modalità sola lettura -->
        <template v-slot:append>
          <!-- Tooltip con icona di blocco in modalità sola lettura -->
          <v-tooltip v-if="onlyView" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <LockIcon class="my-auto !h-5 !w-5 cursor-not-allowed"/>
              </span>
            </template>
            <span>È possibile modificare il nome del modello "{{ risorsa.nome }}" dalla sezione Modelli E-Mail.</span>
          </v-tooltip>
        </template>
      </v-text-field>



    

      <div class="px-4 py-6 bg-gray-100 dark:!bg-csenBlue-950/50 dark:!text-white ring-1 ring-gray-300 rounded-md">
        <div class="flex flex-wrap">
          <!-- Oggetto -->
          <div class="w-full md:w-1/2 md:pr-2">
            <v-text-field
              label="Oggetto"
              v-model="risorsa.oggetto"
              outlined
              placeholder="Oggetto dell'email"
              :rules="[rules.required]"
              :readonly="onlyView"
              :disabled="onlyView"
              @input="$emit('modello-email-modifica-sospesa')"
            >
              <template v-slot:append>
                <!-- Tooltip con icona di blocco in modalità sola lettura -->
                <v-tooltip v-if="onlyView" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <LockIcon class="my-auto !h-5 !w-5 cursor-not-allowed"/>
                    </span>
                  </template>
                  <span>È possibile modificare l'oggetto del modello "{{ risorsa.nome }}" dalla sezione Modelli E-Mail.</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </div>

          <!-- Reply-to -->
          <div class="w-full md:w-1/2 md:pl-2">
            <v-text-field
              label="Reply-to"
              v-model="risorsa.rispondi_a"
              outlined
              placeholder="esempio@email.it"
              :rules="[rules.email]"
              :readonly="onlyView"
              :disabled="onlyView"
              @input="$emit('modello-email-modifica-sospesa')"
            >
              <template v-slot:append>
                <!-- Tooltip con icona di blocco in modalità sola lettura -->
                <v-tooltip v-if="onlyView" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <LockIcon class="my-auto !h-5 !w-5 cursor-not-allowed"/>
                    </span>
                  </template>
                  <span>È possibile modificare il campo reply-to del modello "{{ risorsa.nome }}" dalla sezione Modelli E-Mail.</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </div>
        </div>

        <!-- Anteprima -->
        <v-text-field
          label="Anteprima"
          v-model="risorsa.anteprima"
          class="w-full"
          outlined
          placeholder="Inserire anteprima da visualizzare nell'email"
          :readonly="onlyView"
          :disabled="onlyView"
          @input="$emit('modello-email-modifica-sospesa')"
        >
          <template v-slot:append>
                  <!-- Tooltip con icona di blocco in modalità sola lettura -->
                  <v-tooltip v-if="onlyView" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <LockIcon class="my-auto !h-5 !w-5 cursor-not-allowed"/>
                      </span>
                    </template>
                    <span>È possibile modificare l'anteprima del modello "{{ risorsa.nome }}" dalla sezione Modelli E-Mail.</span>
                  </v-tooltip>
                </template>
        </v-text-field>

        <!-- Dynamic References (shown only if not in onlyView mode) -->
        <div class="mx-1 font-sans mb-5" v-if="!onlyView">
          <div class="font-semibold text-gray-950 dark:text-csenBlue-100 mb-2"><h3>Riferimenti dinamici</h3></div>
          <v-row class="mt-1">
            <v-chip
              @click="inserisciRiferimentoDinamico('{NOME}')"
              class="ml-2 mb-1 !bg-white !text-[#404040] !ring-1 !rounded-none !ring-[#ccc] !tracking-widest hover:!text-[#06c] !transtion"
            >
              NOME
            </v-chip>
            <v-chip
              @click="inserisciRiferimentoDinamico('{COGNOME}')"
              class="ml-2 mb-1 !bg-white !text-[#404040] !ring-1 !rounded-none !ring-[#ccc] !tracking-widest hover:!text-[#06c] !transtion"
            >
              COGNOME
            </v-chip>
            <v-chip
              @click="inserisciRiferimentoDinamico('{ANNO_ATTUALE}')"
              class="ml-2 mb-1 !bg-white !text-[#404040] !ring-1 !rounded-none !ring-[#ccc] !tracking-widest hover:!text-[#06c] !transtion"
              >
              ANNO ATTUALE
            </v-chip>
            <v-chip
              @click="inserisciRiferimentoDinamico('{ANNO_RIFERIMENTO}')"
              class="ml-2 mb-1 !bg-white !text-[#404040] !ring-1 !rounded-none !ring-[#ccc] !tracking-widest hover:!text-[#06c] !transtion"
              >
              ANNO DI RIFERIMENTO DEL RINNOVO
            </v-chip>
          </v-row>
        </div>

        <vue-editor
          ref="textEditor"
          v-model="risorsa.corpo"
          :editor-toolbar="textEditorToolbar"
          :editorOptions="editorSettings"
          :style="(redBorderTextEditor ? 'border: 1px solid red;' : '') + (onlyView ? 'color: rgba(0,0,0,.38); cursor: default;' : '')"
          :disabled="onlyView"
          :readonly="onlyView"
          :placeholder="onlyView ? '' : 'Testo dell\'email'"
          @focus="modelloEmailFocused = true"
          @text-change="controllaModelloEmailModificato()"
        />
          <!-- @text-change="$emit('modello-email-modifica-sospesa')" -->
      </div>
    </v-form>
  </div>
</template>

<script>
  import mixin from '../mixin';
  import store from '../store';
  import LockIcon from './icons/LockIcon.vue';
  import { VueEditor } from "vue2-editor";

  const risorsa = {
    id: null,
    nome: null,
    oggetto: null,
    corpo: null,
    anteprima: null,
    rispondi_a: null
  };

  export default {
    name: 'ModelloEmailComponent',
    mixins: [mixin],
    props: ['id', 'onlyView', 'dati'],
    components: { VueEditor },
    
    data() {
      return {
        validForm: null,
        // In questo contesto "Risorsa" = "ModelloEmail"
        risorsa: {...risorsa}, // Messo così perché non ha altri oggetti al suo interno e quindi la copia avviene per valore e non per riferimenti
        textEditorToolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ color: [] }],
        ],
        redBorderTextEditor: false,

        modelloEmailFocused: false
      }
    },
    created() {
      if(this.id)
        this.getRisorsa();
      else if(this.dati){
        this.risorsa = this.dati
      }
    },
    watch: {
      id: {
				handler(newVal, oldVal) {
          if(this.id == null){
            this.reset();
          } else {
            this.getRisorsa();
          }
				},
			},
      dati: {
        handler(newVal, oldVal) {
          if(this.dati)
            this.risorsa = this.dati;
          else
            this.reset();
				},
        deep: true
      },
      'risorsa.corpo': {
        handler(newVal, oldVal) {
          if(this.risorsa.corpo && this.risorsa.corpo != '')
            this.redBorderTextEditor = false;
          else
            this.redBorderTextEditor = true;
        },
      }
    },
    methods: {
      getRisorsa(){
        axios.get(`modelli_email/${this.id}`)
          .then(res=>{
            this.risorsa = res.data;
          })
          .catch(err=>{ /* Gestito globalmente con axios interceptor */})
          .finally(()=>{})
      },
      reset(){
        this.risorsa = JSON.parse(JSON.stringify(risorsa));

        this.redBorderTextEditor = false;
        this.modelloEmailFocused = false;

        try { // In certe circostanze poco rilevanti il seguente fallisce.
          this.$refs['form'].resetValidation()
        } catch (error) {}
      },

      inserisciRiferimentoDinamico(testo){
        let quill = this.$refs.textEditor.quill;
        let cursore = quill.getSelection();
        if(cursore){ // Se sono fuori dalla casella di testo sarà null
          let indexCursore = cursore.index;
          quill.insertText(indexCursore, testo, '', true);
        }
      },

      valida(){
        if(this.$refs['form'].validate() && this.risorsa.corpo && this.risorsa.corpo != ""){
          return true;
				} else {
          if(!this.risorsa.corpo || this.risorsa.corpo == ""){
            this.redBorderTextEditor = true;
          }
          return false;
				}
      },
      aggiungiModifica(){
        if(!this.valida()){
          store.commit('mostraSnack', {messaggio: 'Alcuni campi obbligatori non sono compilati correttamente', tipo: 'error'})
          return
        }

        if(this.risorsa.id == null){ // Sono in aggiunta
          axios.post(`modelli_email`, this.risorsa)
            .then(res => {
              this.reset();
              store.commit('mostraSnack', {messaggio: 'Modello inserito con successo', tipo: 'success'})
              this.$emit('modello-email-aggiunto-modificato');
            })
        } else { // Sono in modifica
          axios.patch(`modelli_email/${this.risorsa.id}`, this.risorsa)
            .then(res => {
              store.commit('mostraSnack', {messaggio: 'Modello modificato con successo', tipo: 'success'})
              this.$emit('modello-email-aggiunto-modificato');
            })
        }
      },

      controllaModelloEmailModificato(){
        // Se era stato precedentemente focussato, allora giunti qui è stato effettivamente modificato
        if(this.modelloEmailFocused){
          this.$emit('modello-email-modifica-sospesa')
        }
      },
    },
    computed: {
      editorSettings(){
        if(!this.onlyView)
          return {}
        else
          return {
            modules: {
              toolbar: false,
            }
          }
      }
    }
  }
</script>

<style>

/* NEL MODELLO EMAIL NON VOGLIO LA DARK MODE */
  .ql-toolbar {background-color:white !important;}
  .dark .ql-toolbar {background-color:white !important;}
  /* .dark .ql-editor {color:white} */
  .ql-container {
   background-color:white !important;
   color:#333 !important;
} 

</style>
